import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material/material.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { dashboardService, headerLogoService } from './common.service';
import { LoaderComponent } from './shared/loader/loader.component';
import { LoaderService } from './services/loader.service';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { SharedModule } from './shared';
import { ToastrModule } from 'ngx-toastr';
import { EnvServiceProvider } from './env-services/env.service.provider';
import { AuthGuard } from './guard/auth.guard';
import { AngularOtpLibModule } from 'angular-otp-box';
import { DatePipe } from '@angular/common';
// import { PagesComponent } from './pages/pages.component';

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    // PagesComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    RouterModule,
    HttpClientModule,
    SharedModule,
    AngularOtpLibModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      progressBar: true,

    })

  ],
  providers: [AuthGuard, dashboardService,
    LoaderService, headerLogoService, EnvServiceProvider, DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }, EnvServiceProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
